<template>
  <div class="home-container flude-container">
    <Slider />
    <Instructions/>
    <LatestSeller/>
    <SSDInfo/>
    <Download />
  </div>
</template>

<script>
import Slider from '@/components/HomeComponents/Slider.vue'
import Instructions from '@/components/HomeComponents/Instructions.vue'
import LatestSeller from '@/components/HomeComponents/LatestSeller.vue'
import SSDInfo from '@/components/HomeComponents/SSDInfo.vue'
import Download from '@/components/HomeComponents/Download.vue'

export default {
  components:{
    Slider,
    Instructions,
    LatestSeller,
    SSDInfo,
    Download,
  }
}
</script>
